(function () {
  if (window.__hoCartHooked) return;
  window.__hoCartHooked = true;
  var nativeFetch = window.fetch, sequence = 0, cached = null, flight = null;
  var tail = Promise.resolve(), timer = 0, freshFor = 1200;
  var api = window.HO_CART = { data: null, pending: 0, reads: 0, hits: 0 };
  function route(input) {
    try {
      var u = new URL(typeof input === 'string' ? input : input.url, location.href);
      if (u.origin !== location.origin) return '';
      if (/\/cart\.(js|json)$/.test(u.pathname)) return 'read';
      if (/\/cart\/(add|change|update|clear)(\.(js|json))?$/.test(u.pathname)) return 'write';
    } catch (e) {}
    return '';
  }
  function isCart(c) { return c && Array.isArray(c.items) && typeof c.item_count === 'number' && typeof c.total_price === 'number'; }
  function publish(c, seq) {
    if (!isCart(c) || seq !== sequence) return;
    api.data = c;
    if (window.HO_TIER) window.HO_TIER.cart = c;
    clearTimeout(timer);
    timer = setTimeout(function () { if (!api.pending) document.dispatchEvent(new CustomEvent('ho:cart', { detail: api.data })); }, 40);
  }
  function remember(response, seq) {
    if (!response.ok || seq !== sequence) return Promise.resolve();
    return response.clone().json().then(function (c) {
      if (!isCart(c) && c && c.sections && typeof c.sections['api-cart-items'] === 'string') {
        try {
          var section = new DOMParser().parseFromString(c.sections['api-cart-items'], 'text/html');
          var snapshot = section.querySelector('[data-ho-cart-state]');
          if (snapshot) c = JSON.parse(snapshot.textContent);
        } catch (error) {}
      }
      if (!isCart(c) || seq !== sequence) return;
      cached = { seq: seq, at: Date.now(), response: new Response(JSON.stringify(c), { status: 200, headers: { 'Content-Type': 'application/json' } }) };
      publish(c, seq);
    }).catch(function () {});
  }
  function read(input, init) {
    var seq = sequence;
    if (cached && cached.seq === seq && Date.now() - cached.at < freshFor) { api.hits++; return Promise.resolve(cached.response.clone()); }
    if (flight && flight.seq === seq) { api.hits++; return flight.promise.then(function (r) { return r.clone(); }); }
    var entry = { seq: seq };
    api.reads++;
    entry.promise = nativeFetch.call(window, input, init).then(function (r) { return remember(r, seq).then(function () { return r; }); });
    flight = entry;
    function end() { if (flight === entry) flight = null; }
    entry.promise.then(end, end);
    return entry.promise.then(function (r) { return r.clone(); });
  }
  function settled() {
    clearTimeout(timer);
    timer = setTimeout(function () { var seq = sequence; api.refresh().then(function (c) { publish(c, seq); }).catch(function () {}); }, 120);
  }
  api.accept = function (cart) {
    if (!isCart(cart) || api.pending) return false;
    cached = { seq: sequence, at: Date.now(), response: new Response(JSON.stringify(cart), { status: 200, headers: { 'Content-Type': 'application/json' } }) };
    publish(cart, sequence);
    return true;
  };
  api.refresh = function () {
    return tail.then(function () { return read((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); }).then(function (r) {
      if (!r.ok) throw new Error('Cart refresh failed');
      return r.json();
    });
  };
  window.fetch = function (input, init) {
    var kind = route(input), method = String(init && init.method || input && input.method || 'GET').toUpperCase();
    if (kind === 'read' && method === 'GET') return tail.then(function () { return read(input, init); });
    if (kind !== 'write' || method === 'GET') return nativeFetch.apply(this, arguments);
    api.pending++;
    var work = tail.then(function () {
      var seq = ++sequence;
      cached = null; flight = null; api.data = null;
      return nativeFetch.call(window, input, init).then(function (r) { return remember(r, seq).then(function () { return r; }); });
    });
    tail = work.then(function () {}, function () {});
    function end() { api.pending = Math.max(0, api.pending - 1); if (!api.pending) settled(); }
    work.then(end, end);
    return work;
  };
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__hoWrite = route(url) === 'write' && String(method).toUpperCase() !== 'GET'; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__hoWrite) {
        var seq = ++sequence; cached = null; flight = null; api.data = null; api.pending++;
        xhr.addEventListener('loadend', function () {
          cached = null; flight = null;
          api.pending = Math.max(0, api.pending - 1);
          if (xhr.status >= 200 && xhr.status < 300) { try { var c = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText); if (isCart(c) && seq === sequence) { cached = { seq: seq, at: Date.now(), response: new Response(JSON.stringify(c), { headers: { 'Content-Type': 'application/json' } }) }; publish(c, seq); } } catch (e) {} }
          if (!api.pending) settled();
        }, { once: true });
      }
      try { return send.apply(this, arguments); } catch (e) { if (xhr.__hoWrite) { api.pending = Math.max(0, api.pending - 1); settled(); } throw e; }
    };
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { cached = null; api.refresh().catch(function () {}); } });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') cached = null; });
})();
